import { _ } from "libs";
import React, { useContext, MouseEvent } from "react";
import SubPageLayout from "./subPageLayout";
import ReservationPageContext from "./reservationPageContext";
import cx from "classnames";
import { Championship } from "../../../types";
import { now } from "moment";

const ChampionshipSelect = () => {
	const pageContext = useContext(ReservationPageContext);
	const {
		reservation: { params, context },
		getReservationContext,
	} = pageContext;

	const selectChampionship = (championshipId: string | Boolean, e: MouseEvent<HTMLDivElement>) => {
		const cells = document.getElementsByClassName("cell");
		for (let i = 0; i < cells.length; i++) {
			const cell = cells[i];
			if (cell.classList.contains("selectedCell")) {
				cell.classList.replace("selectedCell", "selectableCell");
			}
		}

		const el = e.currentTarget as HTMLDivElement;
		el.classList.replace("selectableCell", "selectedCell");

		getReservationContext({ championshipId });
	};

	const getClassName = (championship: Championship | null, selectedId: string): string => {
		return cx("cell", {
			selectableCell: selectedId !== championship?.uuid,
			selectedCell: selectedId === championship?.uuid,
			disabledCell: championship && championship.available === false,
		});
	};

	return (
		<SubPageLayout title={_("bookingWizard.championship.heading")}>
			<div className="wizardBody">
				<div className="table dominantLabels">
					<div
						className={getClassName(null, params.championshipId)}
						onClick={selectChampionship.bind(false, false)}
					>
						<div className="tableRow">
							<div className="tableRowIcon" />
							<div className="tableRowLabel">{_("championship.none")}</div>
						</div>
					</div>
					{context.championships
						.filter((ch) => ch.optedIn)
						.filter((ch) => ch.endDateTime > Date.now() / 1000)
						.map((championship) => (
							<div
								key={championship.uuid}
								className={getClassName(championship, params.championshipId)}
								onClick={
									championship.available ? selectChampionship.bind(null, championship.uuid) : null
								}
							>
								<div className="tableRow">
									<div className="tableRowIcon" />
									<div className="tableRowLabel">{championship.name}</div>
									{!championship.available && (
										<div className="msg locked small w-full mt-2">
											{championship.notAvailableReason}
										</div>
									)}
								</div>
							</div>
						))}
				</div>
				{/* DESCOPED <div className="discoverChampionships">
					<Link to={"/leaderboard"}>{_("bookingWizard.championship.discoverLink")}</Link>
				</div> */}
			</div>
		</SubPageLayout>
	);
};
export default ChampionshipSelect;
